import logo from "./logo.svg";
import "./App.css";
import "./App.scss";
import { useState } from "react";
import OnOffVideo from "./pages/OnOffVideo/OnOffVideo";
import EndImage from "./pages/EndImage/EndImage";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  const [videoDisplay, setVideoDisplay] = useState(null);
  var style = {};

  // return (
  //   <div className="App">
  //     <div>
  //       <video
  //         width="1000"
  //         autoPlay
  //         muted
  //         onEnded={videoEnded}
  //         id="productVideo"
  //       >
  //         <source src="/product2.mp4" type="video/mp4" />
  //       </video>
  //       {/* <img width="1000" src="/end.png" id="endImg" style={{display: "none"}}/> */}
  //     </div>
  //   </div>
  // );
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<OnOffVideo />} />
        <Route path="/home" element={<OnOffVideo />} />
        <Route path="/home2" element={<EndImage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
